import React from "react";
import styles from "./features.module.scss";
import {
  bottomcards,
  extracards,
  topcards,
} from "../constants/home/features.constants";
import Card from "../components/Cards";

const Fifth = () => {
  return (
    <div className={styles.root}>
      <section className={styles.top}>
        <span className={styles.title}>Features</span>
        <span className={styles.description}>
          Experience the best Features Sentinel has to offer you by using
          Sentinel dVPN application
        </span>
      </section>
      <section className={styles.center}>
        <section className={styles.topcards}>
          {topcards.map((c, i) => {
            return (
              <Card
                key={`top-cards-${i}`}
                className={`${styles.card} ${styles[`card-${i}`]}`}
              >
                {c.img && (
                  <section className={styles.imgs}>
                    <img src={c.img} alt="" />
                  </section>
                )}
                <section className={styles.explain}>
                  <span className={styles.title}>{c.title}</span>
                  <span className={styles.description}>{c.description}</span>
                </section>
              </Card>
            );
          })}
        </section>
        <section className={styles.bottomcards}>
          {bottomcards.map((c, i) => {
            return (
              <Card
                key={`bottom-cards-${i}`}
                className={`${styles.card} ${styles[`card-${i}`]}`}
              >
                <section className={styles.imgs}>
                  <img src={c.img} alt="" />
                </section>
                <section className={styles.explain}>
                  <span className={styles.title}>{c.title}</span>
                  <span className={styles.description}>{c.description}</span>
                </section>
              </Card>
            );
          })}
        </section>
        <section className={styles.extracards}>
          {extracards.map((c, i) => {
            return (
              <Card
                key={`bottom-cards-${i}`}
                className={`${styles.card} ${styles[`card-${i}`]}`}
              >
                {c.img && (
                  <section className={styles.imgs}>
                    <img src={c.img} alt="" />
                  </section>
                )}

                <section className={styles.explain}>
                  <span className={styles.title}>{c.title}</span>
                  <span className={styles.description}>{c.description}</span>
                </section>
              </Card>
            );
          })}
        </section>
      </section>
    </div>
  );
};

export default Fifth;
